import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e38c247"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Лавлагаа")
const _hoisted_5 = {
  key: 0,
  class: "row g-10"
}
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "card card-stretch shadow mb-5" }
const _hoisted_8 = { class: "card-header flex-wrap gap-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Үндсэн зээлдэгч")
], -1))
const _hoisted_10 = {
  key: 0,
  class: "reference-mode-switch"
}
const _hoisted_11 = { class: "reference-mode-switch-inside" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = { class: "col-md-10" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Хуулийн статус:", -1))
const _hoisted_15 = { style: {"float":"left"} }
const _hoisted_16 = { style: {"float":"right","color":"#8492a6","font-size":"13px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = { class: "col-md-10" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Хайх талбар:", -1))
const _hoisted_20 = { style: {"float":"left"} }
const _hoisted_21 = { style: {"float":"left"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = { class: "col-md-10 demo-input-suffix" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Хайх утга:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { class: "col-md-10" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Төрөл:", -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Иргэн")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Хуулийн этгээд")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = { class: "form-label col-md-4" }
const _hoisted_32 = { class: "col-md-8 advanced-row-inputs" }
const _hoisted_33 = {
  key: 1,
  class: "advanced-operator advanced-operator-empty"
}
const _hoisted_34 = { class: "card-footer" }
const _hoisted_35 = ["data-kt-indicator", "disabled"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Хайх ", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = { class: "col-lg-6" }
const _hoisted_40 = { class: "card shadow mb-5" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Холбогдох этгээд")
  ])
], -1))
const _hoisted_42 = { class: "card-body" }
const _hoisted_43 = { class: "col-md-10" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Холбогдох статус:", -1))
const _hoisted_45 = { style: {"float":"left"} }
const _hoisted_46 = { style: {"float":"right","color":"#8492a6","font-size":"13px"} }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_48 = { class: "col-md-10" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Хайх талбар:", -1))
const _hoisted_50 = { style: {"float":"left"} }
const _hoisted_51 = { style: {"float":"left"} }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_53 = { class: "col-md-10 demo-input-suffix" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label col-md-5" }, "Хайх утга:", -1))
const _hoisted_55 = { class: "card-footer" }
const _hoisted_56 = ["data-kt-indicator", "disabled"]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Хайх ", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Түр хүлээнэ үү... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_59 = [
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = {
  key: 1,
  class: "d-flex flex-column align-items-center justify-content-center text-center py-20"
}
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle text-danger",
    style: {"font-size":"40px"}
  })
], -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "fw-bold mb-3 text-gray-800" }, " Хандах эрхгүй ", -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-muted fs-6 mb-6" }, " Та энэ хэсэгт хандах эрхгүй байна. ", -1))
const _hoisted_64 = [
  _hoisted_61,
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = {
  key: 0,
  class: "card shadow"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Хайлтын үр дүн")
  ])
], -1))
const _hoisted_67 = {
  class: "card-body",
  style: {"padding":"0"}
}
const _hoisted_68 = {
  key: 0,
  class: "table table-rounded table-striped border gy-3 gs-3"
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", {
    align: "center",
    class: "fw-bold fs-5 fw-bolder border-bottom border-gray-400 fs-4"
  }, [
    /*#__PURE__*/_createElementVNode("th", { colspan: 2 }, " Доорх утганд тохирох зээлдэгчийн мэдээлэл олдсонгүй. ")
  ])
], -1))
const _hoisted_70 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хуулийн статус:", -1))
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = {
  key: 0,
  class: "fw-bold fs-5 text-gray-800 border border-gray-200"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Харгалзах хайх талбар:", -1))
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { key: 1 }
const _hoisted_78 = {
  key: 1,
  class: "fw-bold fs-5 text-gray-800 border border-gray-200"
}
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Лав хайлтын нөхцөл:", -1))
const _hoisted_80 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хайсан утга:", -1))
const _hoisted_82 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хайсан огноо:", -1))
const _hoisted_84 = {
  key: 1,
  class: "table table-rounded table-striped border gy-3 gs-3"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", {
    align: "center",
    class: "fw-bold fs-5 fw-bolder border-bottom border-gray-400 fs-4"
  }, [
    /*#__PURE__*/_createElementVNode("th", { colspan: 2 }, " Доорх утганд тохирох хамтран зээлдэгчийн мэдээлэл олдсонгүй. ")
  ])
], -1))
const _hoisted_86 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хуулийн статус:", -1))
const _hoisted_88 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Харгалзах хайх талбар:", -1))
const _hoisted_90 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хайсан утга:", -1))
const _hoisted_92 = { class: "fw-bold fs-5 text-gray-800 border border-gray-200" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Хайсан огноо:", -1))
const _hoisted_94 = ["onClick"]
const _hoisted_95 = ["disabled", "onClick"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-pdf text-danger fs-3" }, null, -1))
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = ["onClick"]
const _hoisted_99 = ["disabled", "onClick"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-pdf text-danger fs-3" }, null, -1))
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = ["onClick"]
const _hoisted_103 = ["disabled"]
const _hoisted_104 = ["disabled", "onClick"]
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-pdf text-danger fs-3" }, null, -1))
const _hoisted_106 = [
  _hoisted_105
]
const _hoisted_107 = ["onClick"]
const _hoisted_108 = ["disabled"]
const _hoisted_109 = ["disabled", "onClick"]
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-pdf text-danger fs-3" }, null, -1))
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = {
  key: 4,
  class: "inquiry-overlay"
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inquiry-overlay-content" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm me-2" }),
  /*#__PURE__*/_createTextVNode(" Лавлагаа бэлтгэж байна түр хүлээнэ үү... ")
], -1))
const _hoisted_114 = [
  _hoisted_113
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    (
      this.role.includes('ROLE_ADMIN') || this.role.includes('ROLE_GET_INQUIRY')
    )
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                (
                this.role.includes('ROLE_ADMIN') ||
                  this.role.includes('ROLE_DEEP_SEARCH')
              )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["btn btn-sm", 
                    _ctx.searchMode === 'simple'
                      ? 'btn-primary'
                      : 'btn-light-primary'
                  ]),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setSearchMode('simple')))
                        }, " Энгийн хайлт ", 2),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["btn btn-sm", 
                    _ctx.searchMode === 'advanced'
                      ? 'btn-primary'
                      : 'btn-light-primary'
                  ]),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setSearchMode('advanced')))
                        }, " Лав хайлт ", 2)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.searchMode === 'simple')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createVNode(_component_el_select, {
                          id: "legalStatusSelect",
                          modelValue: _ctx.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value) = $event)),
                          class: "col-md-7",
                          onChange: _ctx.resetResultFieldsLegalStatus,
                          placeholder: "Хуулийн статус"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.legalStatus, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.label,
                                value: item.value
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_15, _toDisplayString(item.label), 1),
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(item.value), 1)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _hoisted_17,
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.val,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.val) = $event)),
                          class: "col-md-7",
                          placeholder: "Select",
                          onChange: _ctx.resetResultFields
                        }, {
                          default: _withCtx(() => [
                            (_ctx.value === '01' || _ctx.value === '02')
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.citizenFields, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.val,
                                    label: item.label,
                                    value: item.val
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_20, _toDisplayString(item.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.orgFields, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.val,
                                    label: item.label,
                                    value: item.val
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_21, _toDisplayString(item.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _hoisted_22,
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _createVNode(_component_el_input, {
                          id: "searchValueSimple",
                          onKeyup: _withKeys(_ctx.getCustomerReference, ["enter"]),
                          modelValue: _ctx.searchValue,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchValue) = $event)),
                          class: "col-md-7",
                          placeholder: "Хайх утга",
                          disabled: _ctx.inquiryLoading
                        }, null, 8, ["onKeyup", "modelValue", "disabled"])
                      ]),
                      _hoisted_25
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.advanced.subjectType,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.advanced.subjectType) = $event)),
                          class: "col-md-7",
                          onChange: _ctx.handleAdvancedSubjectChange
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "citizen" }, {
                              default: _withCtx(() => [
                                _hoisted_28
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "organization" }, {
                              default: _withCtx(() => [
                                _hoisted_29
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue", "onChange"])
                      ]),
                      _hoisted_30,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentAdvancedFields, (field, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: field.key,
                          class: "col-md-12 advanced-row"
                        }, [
                          _createElementVNode("label", _hoisted_31, _toDisplayString(field.label) + ":", 1),
                          _createElementVNode("div", _hoisted_32, [
                            (index > 0)
                              ? (_openBlock(), _createBlock(_component_el_select, {
                                  key: 0,
                                  modelValue: _ctx.advanced.connectors[field.key],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.advanced.connectors[field.key]) = $event),
                                  class: "advanced-operator",
                                  placeholder: "and/or",
                                  onChange: _ctx.resetResultFields
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "AND",
                                      value: "and"
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "OR",
                                      value: "or"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_33, " AND ")),
                            _createVNode(_component_el_input, {
                              id: `advanced-${field.key}`,
                              modelValue: _ctx.advanced.values[field.key],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.advanced.values[field.key]) = $event),
                              class: "advanced-input",
                              placeholder: field.label,
                              disabled: _ctx.inquiryLoading,
                              onKeyup: _withKeys(_ctx.getAdvancedCustomerReference, ["enter"]),
                              onInput: _ctx.resetResultFields
                            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "placeholder", "disabled", "onKeyup", "onInput"])
                          ])
                        ]))
                      }), 128))
                    ], 64))
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("button", {
                  class: "el-button el-button--primary el-button--mini col-lg-4",
                  size: "mini",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (
                _ctx.searchMode === 'advanced'
                  ? _ctx.getAdvancedCustomerReference()
                  : _ctx.getCustomerReference()
              )),
                  "data-kt-indicator": this.loadButtonSimple,
                  disabled: _ctx.inquiryLoading
                }, _hoisted_38, 8, _hoisted_35)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.coValue,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.coValue) = $event)),
                    class: "col-md-7",
                    onChange: _ctx.resetResultFieldsCoLegalStatus,
                    placeholder: "Хуулийн статус"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coStatus, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.coValue,
                          label: item.coLabel,
                          value: item.coValue
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_45, _toDisplayString(item.coLabel), 1),
                            _createElementVNode("span", _hoisted_46, _toDisplayString(item.coValue), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _hoisted_49,
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.coVal,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.coVal) = $event)),
                    class: "col-md-7",
                    placeholder: "Select",
                    onChange: _ctx.resetResultFields
                  }, {
                    default: _withCtx(() => [
                      (_ctx.coValue === '01')
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.coFieldsCitizen, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.coVal,
                              label: item.coLabel,
                              value: item.coVal
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_50, _toDisplayString(item.coLabel), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.coFieldsOrg, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.coVal,
                              label: item.coLabel,
                              value: item.coVal
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_51, _toDisplayString(item.coLabel), 1)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createVNode(_component_el_input, {
                    id: "searchValueRel",
                    onKeyup: _withKeys(_ctx.getCoCustomerReference, ["enter"]),
                    modelValue: _ctx.coSearchValue,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.coSearchValue) = $event)),
                    class: "col-md-7",
                    placeholder: "Хайх утга",
                    disabled: _ctx.inquiryLoading
                  }, null, 8, ["onKeyup", "modelValue", "disabled"])
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _createElementVNode("button", {
                  class: "el-button el-button--primary el-button--mini col-lg-4",
                  size: "mini",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.getCoCustomerReference && _ctx.getCoCustomerReference(...args))),
                  "data-kt-indicator": this.loadButtonSimple,
                  disabled: _ctx.inquiryLoading
                }, _hoisted_59, 8, _hoisted_56)
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_60, _hoisted_64)),
    (this.loadButtonSimple === 'on')
      ? (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 2,
          rows: 5,
          animated: ""
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
          (_ctx.result)
            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                _hoisted_66,
                _createElementVNode("div", _hoisted_67, [
                  (_ctx.customerResultCode === 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_68, [
                        _hoisted_69,
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", _hoisted_70, [
                            _hoisted_71,
                            (_ctx.resultSearchMode === 'simple')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_72, _toDisplayString(this.legalStatus.find(item => {
                      return this.value === item.value;
                    })?.label), 1))
                              : (_openBlock(), _createElementBlock("td", _hoisted_73, _toDisplayString(_ctx.resultEntityType === "citizen" ? "Иргэн" : "Хуулийн этгээд"), 1))
                          ]),
                          (_ctx.resultSearchMode === 'simple')
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_74, [
                                _hoisted_75,
                                (this.value === '01' || this.value === '02')
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_76, _toDisplayString(this.citizenFields.find(item => {
                      return this.val === item.val;
                    })?.label), 1))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_77, _toDisplayString(this.orgFields.find(item => {
                      return this.val === item.val;
                    })?.label), 1))
                              ]))
                            : (_openBlock(), _createElementBlock("tr", _hoisted_78, [
                                _hoisted_79,
                                _createElementVNode("td", null, _toDisplayString(this.searchedValue), 1)
                              ])),
                          _createElementVNode("tr", _hoisted_80, [
                            _hoisted_81,
                            _createElementVNode("td", null, _toDisplayString(this.searchedValue), 1)
                          ]),
                          _createElementVNode("tr", _hoisted_82, [
                            _hoisted_83,
                            _createElementVNode("td", null, _toDisplayString(_ctx.getMomentTime(Date.now())), 1)
                          ])
                        ])
                      ]))
                    : (_ctx.coRelResultCode === 0)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_84, [
                          _hoisted_85,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", _hoisted_86, [
                              _hoisted_87,
                              _createElementVNode("td", null, _toDisplayString(this.coStatus.find(item => {
                      return this.coValue === item.coValue;
                    })?.coLabel), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_88, [
                              _hoisted_89,
                              _createElementVNode("td", null, _toDisplayString(this.coValue === "01"
                      ? this.coFieldsCitizen.find(item => {
                          return this.coVal === item.coVal;
                        })?.coLabel
                      : this.coFieldsOrg.find(item => {
                          return this.coVal === item.coVal;
                        })?.coLabel), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_90, [
                              _hoisted_91,
                              _createElementVNode("td", null, _toDisplayString(this.searchedValue), 1)
                            ]),
                            _createElementVNode("tr", _hoisted_92, [
                              _hoisted_93,
                              _createElementVNode("td", null, _toDisplayString(_ctx.getMomentTime(Date.now())), 1)
                            ])
                          ])
                        ]))
                      : (_ctx.customerResultCode !== 0 && _ctx.customerResultCode !== -1)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_ctx.isCitizenResult())
                              ? (_openBlock(), _createBlock(_component_el_table, {
                                  key: 0,
                                  data: _ctx.citizenTableData,
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_table_column, {
                                      label: "#",
                                      width: "80"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "Зээлдэгчийн регистрийн дугаар" }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("span", {
                                          class: "customized-link-span",
                                          onClick: ($event: any) => (_ctx.getCustomerDetails(scope.row.identityno))
                                        }, _toDisplayString(scope.row.identityno), 9, _hoisted_94)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Овог",
                                      prop: "lastname"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Нэр",
                                      prop: "customername"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Регистрийн дугаар",
                                      prop: "registerno"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Лавлагаа",
                                      width: "110",
                                      align: "center"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("button", {
                                          class: "btn btn-sm btn-icon btn-light-primary",
                                          disabled: _ctx.inquiryLoading,
                                          onClick: ($event: any) => (_ctx.downloadCreditInquiry(scope.row.identityno)),
                                          title: "PDF лавлагаа"
                                        }, _hoisted_97, 8, _hoisted_95)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"]))
                              : (_openBlock(), _createBlock(_component_el_table, {
                                  key: 1,
                                  data: _ctx.orgTableData,
                                  style: {"width":"100%"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_table_column, {
                                      label: "#",
                                      prop: "date",
                                      width: "60"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, { label: "Зээлдэгчийн регистрийн дугаар" }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("span", {
                                          class: "customized-link-span",
                                          onClick: ($event: any) => (_ctx.getCustomerDetails(scope.row.identityno))
                                        }, _toDisplayString(scope.row.identityno), 9, _hoisted_98)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Улсын бүртгэлийн дугаар",
                                      prop: "registerno"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Байгууллагын нэр",
                                      prop: "customername"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Захирлын ИБД",
                                      prop: "ceocivilid"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Захирлын овог",
                                      prop: "ceolastname"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Захирлын нэр",
                                      prop: "ceofirstname"
                                    }),
                                    _createVNode(_component_el_table_column, {
                                      label: "Лавлагаа",
                                      width: "110",
                                      align: "center"
                                    }, {
                                      default: _withCtx((scope) => [
                                        _createElementVNode("button", {
                                          class: "btn btn-sm btn-icon btn-light-primary",
                                          disabled: _ctx.inquiryLoading,
                                          onClick: ($event: any) => (_ctx.downloadCreditInquiry(scope.row.identityno)),
                                          title: "PDF лавлагаа"
                                        }, _hoisted_101, 8, _hoisted_99)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["data"]))
                          ], 64))
                        : (_ctx.coRelResultCode !== 0 && _ctx.coRelResultCode !== -1)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (_ctx.coValue === '01')
                                ? (_openBlock(), _createBlock(_component_el_table, {
                                    key: 0,
                                    data: _ctx.coRelCitizenTableData,
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_table_column, {
                                        label: "#",
                                        width: "80"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, { label: "ИБД | РД" }, {
                                        default: _withCtx((scope) => [
                                          _createElementVNode("span", {
                                            class: "customized-link-span",
                                            onClick: ($event: any) => (_ctx.getCustomerDetails(scope.row.identityno))
                                          }, _toDisplayString(scope.row.identityno), 9, _hoisted_102)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "РД | УБД",
                                        prop: "registerno"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Төрөл",
                                        prop: "customertype"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Үндсэн зээлдэгчийн нэр",
                                        prop: "customername"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Холбогдох хэлбэр",
                                        prop: "reltypename"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "ИБД",
                                        prop: "relidentityno"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Регистер",
                                        prop: "relregisterno"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Овог",
                                        prop: "rellastname"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Нэр",
                                        prop: "relsubjectname"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        width: "110",
                                        align: "center"
                                      }, {
                                        header: _withCtx(() => [
                                          _createElementVNode("button", {
                                            class: "btn btn-sm btn-light-primary w-100",
                                            disabled: _ctx.inquiryLoading,
                                            onClick: _cache[11] || (_cache[11] = ($event: any) => (
                      _ctx.downloadRelatedCreditInquiry(
                        (_ctx.coSearchValue || '').toString().trim(),
                        'NA'
                      )
                    ))
                                          }, " Лавлагаа ", 8, _hoisted_103)
                                        ]),
                                        default: _withCtx((scope) => [
                                          _createElementVNode("button", {
                                            class: "btn btn-sm btn-icon btn-light-primary",
                                            disabled: _ctx.inquiryLoading,
                                            onClick: ($event: any) => (
                      _ctx.downloadRelatedCreditInquiry(
                        scope.row.relidentityno,
                        scope.row.loancode
                      )
                    ),
                                            title: "PDF лавлагаа"
                                          }, _hoisted_106, 8, _hoisted_104)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["data"]))
                                : (_openBlock(), _createBlock(_component_el_table, {
                                    key: 1,
                                    data: _ctx.coRelOrgTableData,
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_table_column, {
                                        label: "#",
                                        prop: "date",
                                        width: "60"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createTextVNode(_toDisplayString(scope.$index + 1), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, { label: "ИБД | РД" }, {
                                        default: _withCtx((scope) => [
                                          _createElementVNode("span", {
                                            class: "customized-link-span",
                                            onClick: ($event: any) => (_ctx.getCustomerDetails(scope.row.identityno))
                                          }, _toDisplayString(scope.row.identityno), 9, _hoisted_107)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "РД | УБД",
                                        prop: "registerno"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Төрөл",
                                        prop: "customertype"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Үндсэн зээлдэгчийн нэр",
                                        prop: "customername"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Холбогдох хэлбэр",
                                        prop: "reltypename"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Регистер",
                                        prop: "relidentityno"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "УБ дугаар",
                                        prop: "relregisterno"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        label: "Нэр",
                                        prop: "relsubjectname"
                                      }),
                                      _createVNode(_component_el_table_column, {
                                        width: "110",
                                        align: "center"
                                      }, {
                                        header: _withCtx(() => [
                                          _createElementVNode("button", {
                                            class: "btn btn-sm btn-light-primary w-100",
                                            disabled: _ctx.inquiryLoading,
                                            onClick: _cache[12] || (_cache[12] = ($event: any) => (
                      _ctx.downloadRelatedCreditInquiry(
                        (_ctx.coSearchValue || '').toString().trim(),
                        'NA'
                      )
                    ))
                                          }, " Лавлагаа ", 8, _hoisted_108)
                                        ]),
                                        default: _withCtx((scope) => [
                                          _createElementVNode("button", {
                                            class: "btn btn-sm btn-icon btn-light-primary",
                                            disabled: _ctx.inquiryLoading,
                                            onClick: ($event: any) => (
                      _ctx.downloadRelatedCreditInquiry(
                        scope.row.relidentityno,
                        scope.row.loancode
                      )
                    ),
                                            title: "PDF лавлагаа"
                                          }, _hoisted_111, 8, _hoisted_109)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["data"]))
                            ], 64))
                          : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64)),
    (_ctx.inquiryLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_112, _hoisted_114))
      : _createCommentVNode("", true)
  ], 64))
}